export const monthsChipsEnum = [
  {
    key: 'january',
    text: 'Jan',
    name: 'Janeiro',
    active: false,
    disabled: false,
  },
  {
    key: 'february',
    text: 'Fev',
    name: 'Fevereiro',
    active: false,
    disabled: false,
  },
  { key: 'march', text: 'Mar', name: 'Março', active: false, disabled: false },
  { key: 'april', text: 'Abr', name: 'Abril', active: false, disabled: false },
  { key: 'may', text: 'Mai', name: 'Maio', active: false, disabled: false },
  { key: 'june', text: 'Jun', name: 'Junho', active: false, disabled: false },
  { key: 'july', text: 'Jul', name: 'Julho', active: false, disabled: false },
  {
    key: 'august',
    text: 'Ago',
    name: 'Agosto',
    active: false,
    disabled: false,
  },
  {
    key: 'september',
    text: 'Set',
    name: 'Setembro',
    active: false,
    disabled: false,
  },
  {
    key: 'october',
    text: 'Out',
    name: 'Outubro',
    active: false,
    disabled: false,
  },
  {
    key: 'november',
    text: 'Nov',
    name: 'Novembro',
    active: false,
    disabled: false,
  },
  {
    key: 'december',
    text: 'Dez',
    name: 'Dezembro',
    active: false,
    disabled: false,
  },
];
